import * as React from 'react';

import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import Leaflet from 'leaflet';

import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';


import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { FlexRow, Item } from "@mui-treasury/component-flex";
import { Info, InfoTitle, InfoSubtitle } from "@mui-treasury/component-info";

import Moment from 'react-moment';

import NFTreeModal from './NFTreeModal';

Leaflet.Marker.prototype.options.icon = Leaflet.icon({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [24,36],
  iconAnchor: [12,36]
});

function getURL(uri:string, width:number, height:number){
    if (uri.startsWith('http')){
        return uri
    } else if (uri.startsWith('ipfs://')){
        const encoded_ipfs_uri = btoa(uri.split("ipfs://")[1]);
        return "https://api.bloomeria.org/image/" + encoded_ipfs_uri + '/' + width + '/' + height 
    }

}

function getNFTreeDescription(metadata, link_color) {
  return <span>
    {metadata.attributes[0].value + " tree planted by " } 
    <Link href={metadata.external_url} target="_blank" sx={{color:link_color}}>RMTerra</Link>
    {" on "} 
    <Moment unix format="YYYY/MM/DD">{metadata.attributes[1].value}</Moment>
    {". Art by "}
    <Link href={metadata['Artist website']} target="_blank" sx={{color:link_color}}>{metadata.attributes[2].value}</Link>
  </span> 
}

const mapHeight = "130px";
const cardWidth = 350;

const StyledCard = styled(Card)(() => ({
  minWidth: 300,
  maxWidth: cardWidth,
  margin: 10,
  position: "relative",
  whiteSpace: "normal",
  boxShadow: "0 8px 24px 0 rgba(0,0,0,0.12)",
  overflow: "hidden",
  borderRadius: "1.5rem",
  transition: "0.4s",

  "&:hover": {
    transform: "translateY(-2px)",
    "& .Shadow1": {
      bottom: "-1.5rem",
    },
    "& .Shadow2": {
      bottom: "-2.5rem",
    },
  },

  "&:before": {
    content: '""',
    position: "absolute",
    zIndex: 0,
    display: "block",
    width: "100%",
    bottom: -1,
    height: "100%",
    borderRadius: "1.5rem",
    backgroundColor: "rgba(0,0,0,0.08)",
  },
}));

const StyledCardMedia = styled(CardMedia)({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  zIndex: 0,
  backgroundColor: "rgba(0, 0, 0, 0.08)",
  backgroundPosition: "center",
});

const BoxMain = styled(Box)(() => ({
    overflow: "hidden",
    borderTopLeftRadius: "1.5rem",
    borderTopRightRadius: "1.5rem",
    zIndex: 1,
  
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      display: "block",
      width: "100%",
      height: "10%",
      background: "linear-gradient(to top, #e6ffff, rgba(0,0,0,0))",
    },
  }));
  
  const StyledDivContent = styled("div")(() => ({
    position: "absolute",
    bottom: 0,
    width: "100%",
    zIndex: 1,
    padding: "1.5rem 1.5rem 1rem",
  }));
  
  const StyledAvatar = styled(Avatar)(() => ({
    width: 90,
    height: 150,
  }));
  
  const StyledDivTag = styled("div")(({theme}) => ({
    display: "inline-block",
    fontFamily: "'Sen', sans-serif",
    backgroundColor:  theme.palette.primary.main,
    borderRadius: "0.5rem",
    padding: "2px 0.5rem",
    color: "#fff",
    marginBottom: "0.5rem",
    position: "absolute",
    bottom: 60
  }));

  const StyledDivText = styled("div")(() => ({
    float:"left",
  }));

  const StyledDivMap = styled("div")(() => ({
    display: "inline-block",
    fontFamily: "'Sen', sans-serif",
    height: mapHeight,
    width: "150px",
    float: "right",
    borderRadius: "0.5rem"
  }));
  
  const TypographyTitle = styled(Typography)(() => ({
    fontFamily: "'Sen', sans-serif",
    fontSize: "1.1rem",
    fontWeight: 800,
    color: "#fff",
    position: "absolute",
    bottom: 30,
    backgroundColor: "#000033",
    borderRadius: "0.5rem",
    padding: "2px 0.3rem",
  }));
  
  const RowAuthor = styled(FlexRow)(() => ({
    zIndex: 1,
    position: "relative",
    borderBottomLeftRadius: "1.5rem",
    borderBottomRightRadius: "1.5rem",
  }));
  
  const Shadow = styled("div")(({ theme }) => ({
    transition: "0.2s",
    position: "absolute",
    zIndex: 0,
    width: "90%",
    height: "100%",
    bottom: 0,
    borderRadius: "1.5rem",
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.08)"
        : "rgba(0,0,0,0.06)",
    left: "50%",
    transform: "translateX(-50%)",
    "& + &": {
      bottom: 0,
      width: "85%",
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.03)"
          : "rgba(0,0,0,0.04)",
    },
  }));


  class NFTree extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
          open: false
        };

        this.setOpen = this.setOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    setOpen(s) {
      this.setState({
        open:s
      });
    }

    handleClose() {
      this.setOpen(false);
    }

    handleOpen() {
      this.setOpen(true);
    };

    render() {
        return (
          <div style={{  display: "inline-block"}}>
            <StyledCard onClick={this.handleOpen}>
        <BoxMain minHeight={400} minWidth={cardWidth} position={"relative"}>
          <StyledCardMedia
            image={getURL(this.props.metadata.image, 400, 400)}
          />
          <StyledDivContent>
        
            <StyledDivText>
                <StyledDivTag>{this.props.metadata.attributes[0]['value']}</StyledDivTag>
                <TypographyTitle variant={"h4"}>
                {this.props.metadata.name}
                </TypographyTitle>
            </StyledDivText>

            <StyledDivMap>
                <MapContainer center={[this.props.metadata.latitude, this.props.metadata.longitude]} zoom={14} zoomControl={false} scrollWheelZoom={false} style={{ height: mapHeight, width: '100%' }} attributionControl={false} dragging={false} >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[this.props.metadata.latitude, this.props.metadata.longitude]}>
                        </Marker>
                    </MapContainer>
            </StyledDivMap>
            
          </StyledDivContent>
        </BoxMain>
        <RowAuthor
          m={0}
          p={1}
          pt={2}
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.900" : "#fff",
          }}
          minWidth={cardWidth}
          minHeight={200}
        >
          <Item p={1} style={{paddingLeft:0}}>
            <StyledAvatar src={getURL(this.props.metadata.tree_picture_ipfs, 400, 200)} />
          </Item>
          <Info sx={{ alignSelf: "center", maxWidth:"70%"}}>
            <InfoTitle>{this.props.metadata.attributes[0]['value']} tree</InfoTitle>
            <InfoSubtitle>{getNFTreeDescription(this.props.metadata, (theme) => theme.palette.info.main )}</InfoSubtitle>
          </Info>
        </RowAuthor>

        <Shadow className="Shadow1" />
        <Shadow className="Shadow2" />

      </StyledCard>

      <NFTreeModal open={this.state.open} onClose={this.handleClose} uri={this.props.uri} metadata={this.props.metadata} getURL={getURL} handleClose={this.handleClose}/>

</div>
        )
    }
}

export default NFTree